import gsap from "gsap";
import is from "is_js";

document.addEventListener("DOMContentLoaded", () => {
    numbersAnimation()
})

function numbersAnimation() {
	let numbersBlock = document.querySelector('.numbers-block')
	if(!numbersBlock) return

	var n = document.querySelector('.numbers-block').offsetWidth / (is.mobile() ? 2.5 : 7),
    speed = 0.08;

	var c = document.getElementById("numbers-animation"),
		ctx = c.getContext("2d"),
		cw = (c.width = document.querySelector('.numbers-block').offsetWidth),
		ch = (c.height = document.querySelector('.numbers-block').offsetHeight),
		bg = new Image(),
		img = new Image(100,100),
		img2 = new Image(100,100),
		img3 = new Image(100,100),
		mouseProps = {x:cw/2, y:cw/2},
		particles = [],
		Particle = function(index) {
			this.index = index;
			this.img = [img,img2,img3][index%3];
			this.x = this.y = this.progress = this.opacity = this.scale = 1;
			this.size = n + 30*((index+1)/n); //min size+
			if (index>n*0.96) this.size*=2; //make some really big foreground particles
			
			this.dur = (2 - 1*((index+1)/n))/speed;
				
				var rot = -rand(3,5); 
				if (index%3==0) rot= -rot;
				
			this.draw = function() {
				var offsetX = -(mouseProps.x-cw/2)*(this.size/2000),
					offsetY = -(mouseProps.y-ch/2)*(this.size/2000),
					size = this.size*this.scale;
					ctx.translate( this.x+offsetX, this.y+offsetY );
				ctx.rotate(rot*this.progress);
				ctx.globalAlpha = this.opacity; 
				ctx.drawImage(this.img, -size/2, -size/2, size, size);
				ctx.rotate(-rot*this.progress);
				ctx.translate( -this.x-offsetX, -this.y-offsetY );
			}
		};


	function setParticle(p, replay) {
	var _tl = gsap.timeline()
				.fromTo(p, {
					x:rand(-p.size/1.5, cw+p.size),
					y:rand(-p.size/1.5, ch+p.size),
					progress:0,
					scale:function(i) {return (p.index%3==0) ? 0.8 : rand(0.5,1.5); }
				},{
					duration:p.dur,
					x:'+='+String( rand(-150, 150) ), 
					y:'+='+String( rand(-100, 100) ), 
					scale:function(i) {return (p.index%3==0) ? rand(0.5,1.5) : 1 ; },
					progress:1,
					ease:'power0.easeNone',
					onComplete:function(){ setParticle(p, true); }
				}, 0)
				.fromTo(p, {
				opacity:0
				}, {
				duration:p.dur/2,
				opacity:1,
				yoyo:true,
				repeat:3,
				ease:'power4.in'
				}, 0)
		if (!replay) _tl.seek(p.dur*rand()); //fast forward only on first run
	}


	// First run
	for (var i=0; i<n; i++) {
		particles.push(new Particle(i));
		setParticle(particles[i]);
	}

	gsap.ticker.add(function(){
		ctx.globalAlpha = 1;
		ctx.globalCompositeOperation = 'source-over';
		ctx.drawImage(bg, 0, 0, cw, ch);
		ctx.globalCompositeOperation = 'lighter';
		for (var i=0; i<n; i++) particles[i].draw();
	});


	window.addEventListener('resize', function() {
		cw = (c.width = document.querySelector('.numbers-block').offsetWidth);
		ch = (c.height = document.querySelector('.numbers-block').offsetHeight);
		for (var i=0; i<n; i++) {
			TweenMax.killTweensOf(particles[i]);
			setParticle(particles[i]);
		}
	});

	window.addEventListener('mousemove', function(e) { gsap.to(mouseProps, {duration:6, x:e.clientX, y:e.clientY, overwrite:true}); });

	// const sensor = new RelativeOrientationSensor();

	window.addEventListener('DeviceOrientation', function(e) { 

		gsap.to(mouseProps, {
			duration:2, 
			x:e.alpha, 
			y:e.beta, 
			overwrite:true
		}); 
	}, false);

	// sensor.start();

	function rand(min=0, max=1) {
		return min + (max-min)*Math.random();
	}

	bg.src = '/local/templates/main/img/photo/design-page/numbers-bg.jpg';
	img.src = '/local/templates/main/img/photo/design-page/circle-1.png';
	img2.src = '/local/templates/main/img/photo/design-page/circle-2.png';
	img3.src = '/local/templates/main/img/photo/design-page/circle-3.png';
}
